export const ASSET_DISPLAY_NAMES = {
  USD: 'ABD Doları',
  EUR: 'Euro',
  GBP: 'İngiliz Sterlini',
  CHF: 'İsviçre Frangı',
  CAD: 'Kanada Doları',
  RUB: 'Rus Rublesi',
  AED: 'BAE Dirhemi',
  AUD: 'Avustralya Doları',
  DKK: 'Danimarka Kronu',
  SEK: 'İsveç Kronu',
  NOK: 'Norveç Kronu',
  JPY: 'Japon Yeni',
  KWD: 'Kuveyt Dinarı',
  BHD: 'Bahreyn Dinarı',
  SAR: 'Suudi Arabistan Riyali',
  CNY: 'Çin Yuanı',
  PLN: 'Polonya Zlotisi',
  BGN: 'Bulgar Levası',
  AZN: 'Azerbaycan Manatı',
  QAR: 'Katar Riyali',
  ZAR: 'Güney Afrika Randı',

  GRAM: 'Gram Altın',
  GRAM_HAS: 'Gram Has Altın',
  CEYREK: 'Yeni Çeyrek',
  YARIM: 'Yeni Yarım',
  TAM: 'Yeni Tam',
  XAU_CUM: 'Cumhuriyet Altını',
  ATA: 'Ata Altın',
  AYAR_14: '14 Ayar Altın',
  AYAR_18: '18 Ayar Altın',
  BILEZIK_22: '22 Ayar Bilezik',
  GREMSE: 'Gremse Altın',
  XAGTRYG: 'Gram Gümüş',
  PLATIN: 'Gram Platin',
  PALADYUM: 'Gram Paladyum',
  XAUTRYG: 'Gram Altın',
  XAUTRYG_OLD: 'Gram Altın',
  XAU_QTR: 'Yeni Çeyrek',
  XAU_QTR_NEW: 'Yeni Çeyrek',
  XAU_HALF: 'Yeni Yarım',
  XAU_HALF_NEW: 'Yeni Yarım',
  XAU_FULL: 'Yeni Tam',
  XAU_FULL_NEW: 'Yeni Tam',

  GRA: 'Gram Altın',
  HAS: 'Gram Has Altın',
  CEYREKALTIN: 'Yeni Çeyrek',
  YARIMALTIN: 'Yeni Yarım',
  TAMALTIN: 'Yeni Tam',
  CUMHURIYETALTINI: 'Cumhuriyet Altını',
  ATAALTIN: 'Ata Altın',
  GUMUS: 'Gram Gümüş',
  '14AYARALTIN': '14 Ayar Altın',
  '18AYARALTIN': '18 Ayar Altın',
  YIA: '22 Ayar Bilezik',
  GREMSEALTIN: 'Gremse Altın',
  GPL: 'Gram Platin',
  PAL: 'Gram Paladyum',

  'EURUSD=X': 'EUR/USD',
  'GBPUSD=X': 'GBP/USD',
  'USDJPY=X': 'USD/JPY',
  'USDCHF=X': 'USD/CHF',
  'XU100.IS': 'BIST 100',
  XU100: 'BIST 100',
  BIST100: 'BIST 100',
  BTC: 'Bitcoin',
  ETH: 'Ethereum',
  BRENT: 'Brent Petrol',
  'BTC-USD': 'Bitcoin',
  'ETH-USD': 'Ethereum',
  'BZ=F': 'Brent Petrol'
};

const normalizeAssetKey = (value) => {
  const key = String(value || '').trim().toLocaleUpperCase('tr-TR');
  return key.endsWith('TRY=X') ? key.slice(0, -5) : key;
};

const toTitleCase = (value) => String(value || '')
  .replace(/[-_]+/g, ' ')
  .trim()
  .toLocaleLowerCase('tr-TR')
  .replace(/(^|\s)(\p{L})/gu, (_, space, letter) => `${space}${letter.toLocaleUpperCase('tr-TR')}`);

export function getAssetDisplayName(asset) {
  if (!asset) return '';

  const values = typeof asset === 'string'
    ? [asset]
    : [asset.symbol, asset.code, asset.rawSymbol].filter(Boolean);

  for (const value of values) {
    const directKey = String(value).trim().toLocaleUpperCase('tr-TR');
    const normalizedKey = normalizeAssetKey(value);
    if (ASSET_DISPLAY_NAMES[directKey]) return ASSET_DISPLAY_NAMES[directKey];
    if (ASSET_DISPLAY_NAMES[normalizedKey]) return ASSET_DISPLAY_NAMES[normalizedKey];
  }

  const fallback = typeof asset === 'string'
    ? asset
    : asset.displayName || asset.name || values[0];

  return toTitleCase(fallback);
}
